import { createContext } from 'react';
import { ISoftwareUpdates, RestaurantNotificationEventType } from 'types';

export type TPushesViewSortBy =
	| ''
	| 'Name1-10'
	| 'Name10-1'
	| 'LastUpdate1-10'
	| 'LastUpdate10-1'
	| 'UpdatedByA-Z'
	| 'UpdatedByZ-A'
	| 'SoftwareTypeA-Z'
	| 'SoftwareTypeZ-A';
export type TPushesViewCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'success' | 'error' | 'confirm';

export interface IPushesViewState {
	softwareUpdates: ISoftwareUpdates;
	searchString: string;
	sortBy: TPushesViewSortBy;
	countOfItems: TPushesViewCountOfItems;
	currentPage: number;
	pushEventType: RestaurantNotificationEventType | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const pushesViewInitialState: IPushesViewState = {
	softwareUpdates: { count: 0, items: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	pushEventType: null,
	typeOfModalWindow: null,
};

export interface IPushesViewContext extends IPushesViewState {
	changeSearchString(value: string): void;
	setSortBy(sortBy: TPushesViewSortBy): void;
	setCountOfItems(count: TPushesViewCountOfItems): void;
	changeCurrentPage(page: number): void;
	setPushEventType(value: RestaurantNotificationEventType | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const PushesViewContext = createContext<IPushesViewContext>({
	changeSearchString: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setPushEventType: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...pushesViewInitialState,
});
